(function (module) {
    "use strict";

    module.component('calculationPpg', {
        template: require('./calculationPPGComponent.html'),
        bindings: {
            statisticalForecast: "<",
            pmForecast: "<",
            parameters: "<"
        },
        controller: ['$scope', function(this: $TSFixMe, $scope: $TSFixMe) {
            var $ctrl = this;

            $ctrl.showYears = true;

        }]
    });

})(angular.module('topline.modules'));